<template>
  <div>
    <div>
      <VNavigator title="设置与关于"></VNavigator>
    </div>
    <div>
      <div>
        <router-link to="/aboutUs">
          <div class="about1">
            关于我们
            <div class="line"></div>
          </div>
          <div class="jump">
            <span class="arrow"></span>
          </div>


        </router-link>

      </div>

      <!--<div class="about">-->
      <!--清理缓存-->
      <!--<div class="line"></div>-->
      <!--</div>-->

      <div>
        <div class="about2">
          版本
          <div class="line"></div>
        </div>

        <div class="jump">
          1.0
        </div>

        <div class="tuichu" v-tap="{methods:tuichu}">
          退出
        </div>


      </div>

    </div>

    <div class="link">
      <p class="text">
        燕郊在线提供研发与技术服务
      </p>
    </div>

  </div>


</template>

<script type="text/ecmascript-6">
  import VGoBackBtn from '../components/VGoBackBtn.vue';
  import VNavigator from '../components/VNavigator.vue';
  import netTool from '../api/netTool';
  import { Toast } from 'mint-ui';
  export default{
    components: {VGoBackBtn, VNavigator},
    methods: {
      tuichu () {
        // netTool.exit().then(response => {
        //   if (response.errno === '0') {
            this.$store.commit('clearUserInfo');
            this.$store.commit('clearLoginInfo');
            this.$store.commit('clear')
            Toast({
              message: '退出成功',
              position: 'bottom',
              duration: 1000
            });
            this.$router.push({path: '/login'});
        //   }
        // })
        //   .catch(error => {
        //     console.log(error);
        //   });
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .about1 {
    display: inline-block;
    width: px2rem(600);
    font-size: px2rem(28);
    padding-left: px2rem(59);
    padding-top: px2rem(21);
  }

  .about2 {
    display: inline-block;
    width: px2rem(570);
    font-size: px2rem(28);
    padding-left: px2rem(59);
    padding-top: px2rem(21);
    color: rgba(140, 150, 151, 1);
  }

  .jump {
    width: px2rem(50);
    font-size: px2rem(35);
    color: lightgrey;
    display: inline-block;
    color: rgba(140, 150, 151, 1);
    padding-right: px2rem(10);
    .arrow {
      vertical-align: bottom;
      display: inline-block;
      width: px2rem(32);
      height: px2rem(32);;
      background: url('../assets/img/common/right.png') no-repeat 0 0;
      background-size: 100% 100%;
    }
  }

  .line {
    height: px2rem(2);
    padding-left: px2rem(50);
    margin-top: px2rem(20);
    width: px2rem(600);
    background-color: lightgrey;
  }

  .tuichu {
    position: absolute;
    cursor: pointer;
    width: 80%;
    height: px2rem(80);
    bottom: px2rem(120);
    margin: 0 10%;
    line-height: px2rem(80);
    font-size: px2rem(40);
    border: 1px solid #b1b0b4;
    border-radius: px2rem(10);
    text-align: center;
    color: #99989c;
  }

  .link {
    position: absolute;
    width: 100%;
    bottom: 0;
    font-size: px2rem(26);
    text-align: center;
    margin: 0 auto;
    .text {
      padding: 0 px2rem(10);
      color: #7e8c8d;
      height: px2rem(60);
      line-height: px2rem(60);
    }
  }


</style>



// WEBPACK FOOTER //
// setting.vue?467fbac2